import { Injectable } from '@angular/core';
//import { AuthHttp } from 'angular2-jwt';

import { Observable } from 'rxjs';

@Injectable()
export class ListInvoiceRebService {
  public valFiltres = {};
  public validFilters;
  public currentPage: number = 0;
  public rowsPerPage: number = 20;
  public data_factura_ini: number = (new Date()).getFullYear();
  public data_factura_fi: number = (new Date()).getFullYear();

  public getSearchValues(id) { return (this.valFiltres[id]?this.valFiltres[id]:""); }

  constructor() { }
}
